import { useParams } from 'react-router-dom'
import { useMutation, useQuery } from 'react-query'

import { qs } from '@helpers'
import { useAPI } from '@gopeerproject/chuck'

const CACHE_TIME = Infinity

export const useRecordingData = () => {
  const { recordingId } = useParams()
  const { get } = useAPI()

  const { data: recording, isSuccess: recordingIsSuccess } = useQuery(
    ['recording', recordingId],
    () => get({ url: `/recordings/${recordingId}` }).then((res) => res.data),
    { cacheTime: CACHE_TIME, staleTime: CACHE_TIME }
  )

  const { isSuccess, data: classroom } = useQuery(
    ['classrooms', recording?.classroom.id],
    () =>
      get({ url: `/classrooms/${recording?.classroom.id}` }).then(
        (res) => res.data
      ),
    {
      refetchOnWindowFocus: false,
      refetchOnmount: false,
      refetchOnReconnect: false,
      retry: false,
      staleTime: Infinity,
      enabled: recordingIsSuccess
    }
  )

  return {
    ready: recordingIsSuccess && isSuccess,
    recording,
    classroom
  }
}

export const useRecordingFileUpdates = () => {
  const { get } = useAPI()

  return useMutation(({ fileId, start, end }) => {
    return get({
      url: `/recordings/${fileId}/files?${qs.stringify({
        start,
        end
      })}`
    }).then((res) => res.data)
  })
}
